import { render, staticRenderFns } from "./OrderNote.vue?vue&type=template&id=0c2ce374&scoped=true"
import script from "./OrderNote.vue?vue&type=script&lang=js"
export * from "./OrderNote.vue?vue&type=script&lang=js"
import style0 from "./OrderNote.vue?vue&type=style&index=0&id=0c2ce374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2ce374",
  null
  
)

export default component.exports